<template>
    <div class="works_block">
        <div class="container">
            <h2 class="works_title text-center works_title_pc">
                <span class="animation d-flex justify-content-center mb-2">
                    <span class="animation-block" :class="{'is-active': started}">
                        <span class="animation-block-inner">
                            <span class="animation-block-text bg-dark text-white" v-html="`各国ならびに複数国で`"></span>
                        </span>
                        <span class="animation-block-overlay"></span>
                    </span>
                </span>
                <span class="animation d-flex justify-content-center">
                    <span class="animation-block" :class="{'is-active': started}">
                        <span class="animation-block-inner">
                            <span class="animation-block-text bg-dark text-white" v-html="`横断したプロジェクトをご紹介します`"></span>
                        </span>
                        <span class="animation-block-overlay"></span>
                    </span>
                </span>
            </h2>
            <h2 class="works_title text-center works_title_sp">
                <span class="animation d-flex justify-content-center mb-1">
                    <span class="animation-block" :class="{'is-active': started}">
                        <span class="animation-block-inner">
                            <span class="animation-block-text bg-dark text-white" v-html="`各国ならびに複数国で`"></span>
                        </span>
                        <span class="animation-block-overlay"></span>
                    </span>
                </span>
                <span class="animation d-flex justify-content-center mb-1">
                    <span class="animation-block" :class="{'is-active': started}">
                        <span class="animation-block-inner">
                            <span class="animation-block-text bg-dark text-white" v-html="`横断したプロジェクトを`"></span>
                        </span>
                        <span class="animation-block-overlay"></span>
                    </span>
                </span>
                <span class="animation d-flex justify-content-center">
                    <span class="animation-block" :class="{'is-active': started}">
                        <span class="animation-block-inner">
                            <span class="animation-block-text bg-dark text-white" v-html="`ご紹介します`"></span>
                        </span>
                        <span class="animation-block-overlay"></span>
                    </span>
                </span>
            </h2>
            <WorksCategory :set-filter="setFilter" :current-filter="filter"/>
            <WorksItem :filter="filter" :available-animate="availableAnimate"/>
        </div>
    </div>
</template>

<script>
import WorksCategory from "../../components/works/WorksCategory";
import WorksItem from "../../components/works/WorksItem";
export default {
    name: 'WorksContent',
    components: {
        WorksCategory,
        WorksItem
    },
    data () {
        return {
            filter: '',
            started: false,
            availableAnimate: false
        }
    },
    mounted() {
        this.started = true;
        setTimeout(() => {
            this.availableAnimate = true;
        }, 4700);
    },
    methods: {
        setFilter(filter) {
            this.filter = filter;
        }
    }
}
</script>

<style lang="scss" scoped>
    .animation-block, .animation-block-inner {
        position: relative;
        display: block;
        overflow: hidden;
    }

    .animation {
        .animation-block-overlay {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100.5%);
            transform-origin: left center;
            transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22), opacity 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22);
            opacity: 0;
            z-index: 0;
            &:after {
                content: "";
                background-color: #FFBC07;
                display: block;
                width: 100%;
                height: 100%;
                transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.4s, opacity 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.4s;
            }
        }

        .animation-block-inner {
            transform: translateX(-100.5%);
            transform-origin: left center;
            transition: transform 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1s, opacity 0.7s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1s;
            opacity: 0;
            z-index: 1;
            &:after {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: #000;
                transform-origin: right;
                transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1) 2.5s, opacity 0.6s cubic-bezier(0.895, 0.03, 0.685, 0.22) 2.5s;
                z-index: -1;
            }
            .animation-block-text {
                position: relative;
                background: linear-gradient(to right, #000, #000 50%, #FFF 50%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-size: 200% 100%;
                background-position: 100%;
                transition: background-position 0.6s cubic-bezier(0.075, 0.82, 0.165, 1) 2.5s;
                padding: 0 10px;
            }
        }

        &:nth-child(2) {
            .animation-block-overlay {
                transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.6s, opacity 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.6s;
                &:after {
                    transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1s, opacity 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1s;
                }
            }

            .animation-block-inner {
                transition: transform 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.5s, opacity 0.7s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.5s;
                &:after {
                    transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1) 3.1s, opacity 0.6s cubic-bezier(0.895, 0.03, 0.685, 0.22) 3.1s;
                }
                .animation-block-text {
                    transition: background-position 0.6s cubic-bezier(0.075, 0.82, 0.165, 1) 3.1s;
                }
            }
        }
    }

    .animation-block.is-active .animation-block-inner {
        transform: translateX(0);
        opacity: 1;
        &:after {
            transform: translateX(100.5%);
            opacity: 0;
        }

        .animation-block-text {
            background-position: 0 100%;
        }
    }

    .animation-block.is-active .animation-block-overlay {
        transform: translateX(0);
        opacity: 1;
        &:after {
            transform: translateX(100.5%);
            opacity: 0;
        }
    }

    .works_title {
        font-size: 38px;
        margin-bottom: 71px;
        line-height: 1.5;
    }

    .works_text {
        font-size: 20px;
        font-weight: 500;
        line-height: 1.7;
        margin-bottom: 77px;
    }

    .works_block {
        margin-bottom: 160px;
    }

    .works_title_sp {
        display: none;
    }
    @media screen and (max-width: 767px) {
        .works_block {
            margin-bottom: 100px;
        }
        .works_title_pc {
            display: none;
        }
        .works_title_sp {
            display: block;
        }
        .animation {
            &:first-child {
                .animation-block-overlay {
                    transition: transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22), opacity 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22);
                    &:after {
                        transition: transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.3s, opacity 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.3s;
                    }
                }
                .animation-block-inner {
                    transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.4s, opacity 0.6s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.4s;
                    &:after {
                        transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 2.6s, opacity 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) 2.6s;
                    }
                    .animation-block-text {
                        transition: background-position 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 2.6s;
                    }
                }
            }
            &:nth-child(2) {
                .animation-block-overlay {
                    transition: transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.4s, opacity 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.4s;
                    &:after {
                        transition: transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.7s, opacity 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.7s;
                    }
                }

                .animation-block-inner {
                    transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.8s, opacity 0.6s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.8s;
                    &:after {
                        transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 3.1s, opacity 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) 3.1s;
                    }
                    .animation-block-text {
                        transition: background-position 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 3.1s;
                    }
                }
            }
            &:nth-child(3) {
                .animation-block-overlay {
                    transition: transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.8s, opacity 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.8s;
                    &:after {
                        transition: transform 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.1s, opacity 0.3s cubic-bezier(0.895, 0.03, 0.685, 0.22) 1.1s;
                    }
                }

                .animation-block-inner {
                    transition: transform 0.4s cubic-bezier(0.895, 0.03, 0.685, 0.22) 2.2s, opacity 0.6s cubic-bezier(0.895, 0.03, 0.685, 0.22) 2.2s;
                    &:after {
                        transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 3.6s, opacity 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) 3.6s;
                    }
                    .animation-block-text {
                        transition: background-position 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 3.6s;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 570px) {
        .works_title {
            font-size: 6.8vw;
        }
    }
</style>
